module.exports = __webpack_public_path__ + "static/media/ne.afb34c98.svg";